export default __webpack_public_path__ + "static/media/story2.680cf645.jpeg";